import axios from 'axios'
import { TEST_URl } from '@/utils/constants.js'

const defaultBaseUrl = `${process.env.VUE_APP_BASE_URL}`
const testUrl = localStorage.getItem(TEST_URl)
const baseUrl = testUrl || defaultBaseUrl

export async function createWithdrawalMethodService (userData) {
  const res = await axios.post(`${baseUrl}/withdrawal-methods`, { ...userData })
  return res
}
export async function getWithdrawalMethodsService () {
  const res = await axios.get(`${baseUrl}/withdrawal-methods`)
  return res
}
export async function deleteWithdrawalMethodService (userData) {
  const res = await axios.delete(
    `${baseUrl}/withdrawal-methods/${userData.withdrawalId}`,
    {
      params: {
        twoFaCode: userData.twoFaCode
      }
    }
  )
  return res
}
export async function withdrawalRequestService (userData) {
  const res = await axios.post(`${baseUrl}/withdrawal-requests`, {
    ...userData
  })
  return res
}
export async function approveCancelWithdrawalService (userData) {
  const res = await axios.post(`${baseUrl}/transactions/requests/process`, {
    ...userData
  })
  return res
}
